module.exports = __webpack_public_path__ + "img/cases.3b0dd757.webp";